import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.function.bind";
import _slicedToArray from "/builds/kode-site/career.kode.ru-frontend/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.set";
import _toConsumableArray from "/builds/kode-site/career.kode.ru-frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.array.is-array";
import _defineProperty from "/builds/kode-site/career.kode.ru-frontend/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";

function e(_ref) {
  var _ref$node = _ref.node,
      e = _ref$node === void 0 ? [] : _ref$node,
      t = _ref.from,
      r = _ref.source,
      _ref$parent = _ref.parent,
      a = _ref$parent === void 0 ? t || r : _ref$parent,
      n = _ref.to,
      o = _ref.target,
      _ref$child = _ref.child,
      l = _ref$child === void 0 ? n || o : _ref$child,
      _ref$scope = _ref.scope,
      s = _ref$scope === void 0 ? {} : _ref$scope,
      _ref$meta = _ref.meta,
      i = _ref$meta === void 0 ? {} : _ref$meta,
      _ref$family = _ref.family,
      f = _ref$family === void 0 ? {
    type: 'regular'
  } : _ref$family;
  var c = se(a),
      p = se(f.links),
      u = se(f.owners),
      m = [],
      d = {};

  for (var _t = 0; _t < e.length; _t++) {
    var _r = e[_t];
    _r && (m.push(_r), ie(_r, d));
  }

  var h = {
    seq: m,
    next: se(l),
    meta: i,
    scope: s,
    family: {
      type: f.type || 'crosslink',
      links: p,
      owners: u
    },
    reg: d
  };

  for (var _e2 = 0; _e2 < p.length; _e2++) {
    $(p[_e2]).push(h);
  }

  for (var _e3 = 0; _e3 < u.length; _e3++) {
    ee(u[_e3]).push(h);
  }

  for (var _e4 = 0; _e4 < c.length; _e4++) {
    c[_e4].next.push(h);
  }

  return h;
}

function t(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "combine";
  var r = t + '(',
      a = '',
      n = 0;

  for (var _t2 in e) {
    var _o = e[_t2];
    if (null != _o && (r += a, r += w(_o) ? _o.compositeName.fullName : _o.toString()), n += 1, 25 === n) break;
    a = ', ';
  }

  return r += ')', r;
}

function r(e, t) {
  var r = a(t, e.parent);
  if (e.shortName = t, !e.compositeName) return void (e.compositeName = r);
  var n = e.compositeName;
  n.path = r.path, n.shortName = r.shortName, n.fullName = r.fullName;
}

function a(e, t) {
  var r,
      a,
      n,
      o = e;
  return t ? (n = t.compositeName, 0 === e.length ? (r = n.path, a = n.fullName) : (r = n.path.concat([e]), a = 0 === n.fullName.length ? e : n.fullName + '/' + e)) : (r = 0 === e.length ? [] : [e], a = e), {
    shortName: o,
    fullName: a,
    path: r
  };
}

function n(e, t) {
  je = {
    parent: je,
    value: e,
    template: Z(e).meta.template || je && je.template
  };

  try {
    return t();
  } finally {
    je = je.parent;
  }
}

function o(t, r) {
  var a = function a(e) {
    for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      t[_key - 1] = arguments[_key];
    }

    return a.create(e, t, t);
  };

  return a.graphite = e({
    meta: Fe('event', a, r, t)
  }), a.create = function (e) {
    return ke(a, e), e;
  }, a.watch = R(Oe, a), a.map = function (e) {
    var t, r;
    E(e) && (t = e, r = e.name, e = e.fn);
    var n = o(Ne(a, r), t);
    return Te(a, n, 'map', e), n;
  }, a.filter = function (e) {
    return j(e) ? (console.error('.filter(fn) is deprecated, use .filterMap instead'), l(a, e)) : Ke(a, 'filter', e.fn, [G({
      fn: Y
    })]);
  }, a.filterMap = R(l, a), a.prepend = function (e) {
    var t = o('* → ' + a.shortName, {
      parent: a.parent
    });
    return Te(t, a, 'prepend', e), Pe(a, t), t;
  }, Be(a, a), Ee(a);
}

function l(e, t) {
  return Ke(e, 'filterMap', t, [B({
    fn: Y
  }), K.defined()]);
}

function s(t, r) {
  var a = U(t),
      n = U(t),
      o = He('updates'),
      l = Ae();
  a.after = [{
    type: 'copy',
    to: n
  }], l && l.plain.push(a);

  var i = _defineProperty({
    subscribers: new Map(),
    updates: o,
    defaultState: t,
    stateRef: a,
    getState: R(V, a),
    setState: function setState(e) {
      ke({
        target: i,
        params: e,
        defer: 1
      });
    },
    reset: function reset() {
      for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        e[_key2] = arguments[_key2];
      }

      for (var _i = 0, _e5 = e; _i < _e5.length; _i++) {
        var _t3 = _e5[_i];
        i.on(_t3, function () {
          return i.defaultState;
        });
      }

      return i;
    },
    on: function on(e, t) {
      return i.off(e), oe(i).set(e, De(Ge(e, i, 'on', 1, t))), i;
    },
    off: function off(e) {
      var t = oe(i).get(e);
      return t && (t(), oe(i)["delete"](e)), i;
    },
    map: function map(e, t) {
      var r, n, o;
      E(e) && (r = e, n = e.name, t = e.firstState, e = e.fn);
      var l = i.getState(),
          f = Ae();
      f ? o = null : void 0 !== l && (o = e(l, t));
      var c = s(o, {
        name: Ne(i, n),
        config: r,
        strict: 0
      }),
          p = Ge(i, c, 'map', 0, e);
      return te(c).before = [{
        type: 'map',
        fn: e,
        from: a
      }], f && (f.plain.includes(a) || p.seq.unshift(f.loader)), c;
    }
  }, k, function () {
    return Be(i, {});
  });

  return i.graphite = e({
    scope: {
      state: a
    },
    node: [K.defined(), L({
      store: a
    }), K.changed({
      store: n
    }), L({
      store: n
    })],
    child: o,
    meta: Fe('store', i, r)
  }), Ie && void 0 === t && D("current state can't be undefined, use null instead"), i.watch = i.subscribe = function (e, t) {
    if (!t || !w(e)) {
      j(e) || D('watch requires function handler');

      var _t4 = Ae();

      return _t4 ? _t4.watch.push({
        of: a,
        fn: e
      }) : e(i.getState()), Oe(i, e);
    }

    return j(t) || D('second argument should be a function'), e.watch(function (e) {
      return t(i.getState(), e);
    });
  }, le(i, [o]), Ee(i);
}

function i() {
  for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    e[_key3] = arguments[_key3];
  }

  var t, r, a;
  0 === e.length && D('at least one argument required'), ae(e[0]) && (a = re(e[0]), e = ae(e[0]));
  var n,
      o,
      l = e[e.length - 1];

  if (j(l) ? (r = e.slice(0, -1), t = l) : r = e, 1 === r.length) {
    var _e6 = r[0];
    q(_e6) || (n = _e6, o = 1);
  }

  return o || (n = r, t && (t = Le(t))), Qe(Array.isArray(n), n, a, t);
}

function f(t, r) {
  var a = o(t, r),
      n = a.defaultConfig.handler || function () {
    return console.error("no handler used in " + a.getType()), Promise.resolve();
  };

  Z(a).meta.onCopy = ['runner'], Z(a).meta.unit = a.kind = 'effect', a.use = function (e) {
    return n = e, a;
  };
  var i = a["finally"] = He('finally'),
      f = a.done = l(i, {
    named: 'done',
    fn: function fn(_ref2) {
      var e = _ref2.status,
          t = _ref2.params,
          r = _ref2.result;
      if ('done' === e) return {
        params: t,
        result: r
      };
    }
  }),
      c = a.fail = l(i, {
    named: 'fail',
    fn: function fn(_ref3) {
      var e = _ref3.status,
          t = _ref3.params,
          r = _ref3.error;
      if ('fail' === e) return {
        params: t,
        error: r
      };
    }
  }),
      p = a.doneData = f.map({
    named: 'doneData',
    fn: function fn(_ref4) {
      var e = _ref4.result;
      return e;
    }
  }),
      u = a.failData = c.map({
    named: 'failData',
    fn: function fn(_ref5) {
      var e = _ref5.error;
      return e;
    }
  }),
      m = e({
    scope: {
      getHandler: a.use.getCurrent = function () {
        return n;
      },
      "finally": i
    },
    node: [J({
      fn: function fn(_ref6, _ref7, _ref8) {
        var e = _ref6.params,
            t = _ref6.req;
        var r = _ref7["finally"],
            a = _ref7.getHandler;
        var n = _ref8.page;
        var o,
            l = Ue({
          params: e,
          req: t,
          ok: 1,
          anyway: r,
          page: n
        }),
            s = Ue({
          params: e,
          req: t,
          ok: 0,
          anyway: r,
          page: n
        });

        try {
          o = a()(e);
        } catch (e) {
          return void s(e);
        }

        E(o) && j(o.then) ? o.then(l, s) : l(o);
      }
    })],
    meta: {
      op: 'fx',
      fx: 'runner',
      onCopy: ['finally']
    }
  });
  Z(a).scope.runner = m, Z(a).seq.push(B({
    fn: function fn(e, t, r) {
      return r.parent ? {
        params: e,
        req: {
          rs: function rs(e) {},
          rj: function rj(e) {}
        }
      } : e;
    }
  }), J({
    fn: function fn(e, _ref9) {
      var t = _ref9.runner;
      return ke({
        target: t,
        params: e,
        defer: 1
      }), e.params;
    }
  })), a.create = function (e) {
    var t = function () {
      var e = {};
      return e.req = new Promise(function (t, r) {
        e.rs = t, e.rj = r;
      }), e.req["catch"](function () {}), e;
    }();

    return ke(a, {
      params: e,
      req: t
    }), t.req;
  };
  var d = a.inFlight = s(0, {
    named: 'inFlight'
  }).on(a, function (e) {
    return e + 1;
  }).on(i, function (e) {
    return e - 1;
  }),
      h = a.pending = d.map({
    fn: function fn(e) {
      return e > 0;
    },
    named: 'pending'
  });
  return le(a, [i, f, c, p, u, h, d, m]), a;
}

function c(_ref10) {
  var _o$seq;

  var e = _ref10.source,
      t = _ref10.effect,
      r = _ref10.mapParams;

  var a,
      n = f(),
      o = Z(n).scope.runner,
      l = function l(_ref11, _ref12, _ref13) {
    var e = _ref11.params,
        t = _ref11.req;
    var a = _ref12["finally"],
        n = _ref12.effect;
    var o = _ref13.a,
        l = _ref13.page;
    return ke({
      target: n,
      params: {
        params: r(e, o),
        req: {
          rs: Ue({
            params: e,
            req: t,
            ok: 1,
            anyway: a,
            page: l
          }),
          rj: Ue({
            params: e,
            req: t,
            ok: 0,
            anyway: a,
            page: l
          })
        }
      },
      page: l,
      defer: 1
    });
  };

  if (e) {
    var _t5;

    q(e) ? _t5 = e : (_t5 = i(e), le(n, [_t5]));

    var _r2 = T({
      from: 'store',
      store: te(_t5),
      to: 'a'
    });

    a = [J({
      fn: function fn(e) {
        return e;
      }
    }), _r2, B({
      fn: l
    })], ie(_r2, o.reg);
  } else a = [J({
    fn: l
  })];

  return o.scope.effect = t, o.meta.onCopy.push('effect'), (_o$seq = o.seq).splice.apply(_o$seq, [0, 1].concat(_toConsumableArray(a))), Pe(t, n), n;
}

function p(e, t) {
  var r = {};
  return Je(t, function (t, a) {
    var n = r[a] = o(a, {
      parent: e.parent
    });
    e.on(n, t), Pe(e, n);
  }), r;
}

function u(t, r) {
  var a = new Set(),
      n = new Set(),
      l = new Set(),
      i = new Set(),
      c = e({
    family: {
      type: 'domain'
    }
  }),
      p = {
    history: {
      domains: a,
      stores: n,
      effects: l,
      events: i
    },
    graphite: c
  };
  c.meta = Fe('domain', p, r, t);

  var _map = ['onEvent', 'onEffect', 'onStore', 'onDomain'].map(He),
      _map2 = _slicedToArray(_map, 4),
      m = _map2[0],
      d = _map2[1],
      h = _map2[2],
      g = _map2[3];

  p.hooks = {
    event: m,
    effect: d,
    store: h,
    domain: g
  }, p.onCreateEvent = We(m, i, p), p.onCreateEffect = We(d, l, p), p.onCreateStore = We(h, n, p), p.onCreateDomain = We(g, a, p), p.createEvent = p.event = function (e, t) {
    return m(o(e, {
      parent: p,
      config: t
    }));
  }, p.createEffect = p.effect = function (e, t) {
    return d(f(e, {
      parent: p,
      config: t
    }));
  }, p.createDomain = p.domain = function (e, t) {
    return u({
      name: e,
      parent: p,
      config: t
    });
  }, p.createStore = p.store = function (e, t) {
    return h(s(e, {
      parent: p,
      config: t
    }));
  }, Ee(p);
  var y = p.parent;
  return y && (Je(p.hooks, function (e, t) {
    Me({
      from: e,
      to: y.hooks[t]
    });
  }), y.hooks.domain(p)), p;
}

function m(e) {
  A(e);
  var t = k in e ? e[k]() : e;
  t.subscribe || D('expect observable to have .subscribe');
  var r = o(),
      a = I(Ce, r, void 0);
  return t.subscribe({
    next: r,
    error: a,
    complete: a
  }), r;
}

function d() {
  for (var _len4 = arguments.length, t = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    t[_key4] = arguments[_key4];
  }

  var r, a, n;
  ae(t[0]) && (n = re(t[0]), t = ae(t[0]));

  var _t6 = t,
      _t7 = _slicedToArray(_t6, 4),
      l = _t7[0],
      i = _t7[1],
      f = _t7[2],
      _t7$ = _t7[3],
      c = _t7$ === void 0 ? 0 : _t7$;

  if (void 0 === i && 'source' in l && ('clock' in l && null == l.clock && D('config.clock should be defined'), i = l.clock, f = l.fn, c = l.greedy, r = l.target, a = l.name, l = l.source), void 0 === i && (i = l), a = n || a || l.shortName, l = Xe(l), i = Xe(i), 'boolean' == typeof f && (c = f, f = null), r || (r = q(l) && q(i) ? s(f ? f(V(te(l)), V(te(i))) : V(te(l)), {
    name: a
  }) : o(a)), q(l)) le(l, [ze(i, r, {
    scope: {
      fn: f
    },
    node: [!c && H({
      priority: 'sampler'
    }), T({
      store: te(l),
      to: f ? 'a' : 'stack'
    }), f && B({
      fn: X
    })],
    meta: {
      op: 'sample',
      sample: 'store'
    }
  })]);else {
    var _t8 = U(0),
        _a = U(),
        _n = U(),
        _o2 = Ae();

    _o2 && _o2.plain.push(_t8, _a, _n), Ee(e({
      parent: l,
      node: [L({
        store: _a
      }), T({
        from: 'value',
        store: 1,
        target: _t8
      })],
      family: {
        owners: [l, r, i],
        links: r
      },
      meta: {
        op: 'sample',
        sample: 'source'
      }
    })), le(l, [ze(i, r, {
      scope: {
        fn: f
      },
      node: [L({
        store: _n
      }), T({
        store: _t8
      }), G({
        fn: function fn(e) {
          return e;
        }
      }), !c && H({
        priority: 'sampler'
      }), T({
        store: _a
      }), T({
        store: _n,
        to: 'a'
      }), f && B({
        fn: W
      })],
      meta: {
        op: 'sample',
        sample: 'clock'
      }
    })]);
  }
  return r;
}

function h(t, r) {
  var _ae, _ae2;

  var a = {
    op: 'guard'
  };
  ae(t) && (a.config = re(t), (_ae = ae(t), _ae2 = _slicedToArray(_ae, 2), t = _ae2[0], r = _ae2[1], _ae)), r || (t = (r = t).source);
  var _r3 = r,
      n = _r3.filter,
      l = _r3.greedy,
      _r3$name = _r3.name,
      s = _r3$name === void 0 ? "guard" : _r3$name,
      f = r.target || o(s);
  return w(t) || (t = i(t)), w(n) ? d({
    source: n,
    clock: t,
    target: Ee(e({
      node: [G({
        fn: function fn(_ref14) {
          var e = _ref14.guard;
          return e;
        }
      }), B({
        fn: function fn(_ref15) {
          var e = _ref15.data;
          return e;
        }
      })],
      child: f,
      meta: a,
      family: {
        owners: [t, n, f],
        links: f
      }
    })),
    fn: function fn(e, t) {
      return {
        guard: e,
        data: t
      };
    },
    greedy: l,
    name: s
  }) : (j(n) || D('`filter` should be function or unit'), ze(t, f, {
    scope: {
      fn: n
    },
    node: [G({
      fn: Y
    })],
    meta: a
  })), f;
}

function g(e) {
  var r = o(t(e, 'merge'));
  return Me({
    from: e,
    to: r,
    meta: {
      op: 'merge'
    }
  }), r;
}

function y(e, t, r) {
  if (q(e)) return e;

  if (w(e)) {
    var _a2,
        _n2 = e.parent;

    return S(e) && (_a2 = s(t, {
      parent: _n2,
      name: e.shortName,
      "ɔ": r
    }).on(e, function (e, t) {
      return t;
    })), x(e) && (_a2 = s(t, {
      parent: _n2,
      name: e.shortName,
      "ɔ": r
    }).on(e.done, function (e, _ref16) {
      var t = _ref16.result;
      return t;
    })), _n2 && _n2.hooks.store(_a2), _a2;
  }

  var a = {};
  return Je(e, function (e, t) {
    a[t] = q(e) ? e : s(e, {
      name: t
    });
  }), a;
}

function b(e, t) {
  var r = {},
      a = q(e) ? e.updates : e;
  return Je(t, function (e, t) {
    r[t] = a.filter({
      fn: e
    }), a = a.filter({
      fn: function fn(t) {
        return !e(t);
      }
    });
  }), r.__ = a, r;
}

import k from 'symbol-observable';
var v = {
  __proto__: null,
  store: "store",
  event: "event",
  effect: "effect",
  domain: "domain"
};

var w = function w(e) {
  return (j(e) || E(e)) && 'kind' in e;
};

var N = function N(e) {
  return function (t) {
    return w(t) && t.kind === e;
  };
};

var q = N("store"),
    S = N("event"),
    x = N("effect"),
    _ = N("domain");

var C = {
  __proto__: null,
  unit: w,
  store: q,
  event: S,
  effect: x,
  domain: _
};

var D = function D(e) {
  throw Error(e);
},
    E = function E(e) {
  return 'object' == typeof e && null !== e;
},
    j = function j(e) {
  return 'function' == typeof e;
},
    A = function A(e) {
  E(e) || j(e) || D('expect value to be an object');
};

var z = function z() {
  var e = 0;
  return function () {
    return (++e).toString(36);
  };
};

var M = z(),
    O = z(),
    R = function R(e, t) {
  return e.bind(null, t);
},
    I = function I(e, t, r) {
  return e.bind(null, t, r);
};

var P = function P(e, t, r) {
  return {
    id: O(),
    type: e,
    data: r,
    hasRef: t
  };
};

var F = 0,
    H = function H(_ref17) {
  var _ref17$priority = _ref17.priority,
      e = _ref17$priority === void 0 ? "barrier" : _ref17$priority;
  return P('barrier', 0, {
    barrierID: ++F,
    priority: e
  });
},
    T = function T(_ref18) {
  var _ref18$from = _ref18.from,
      e = _ref18$from === void 0 ? "store" : _ref18$from,
      t = _ref18.store,
      r = _ref18.target,
      _ref18$to = _ref18.to,
      a = _ref18$to === void 0 ? r ? 'store' : 'stack' : _ref18$to;
  return P('mov', 'store' === e, {
    from: e,
    store: t,
    to: a,
    target: r
  });
},
    K = {
  defined: function defined() {
    return P('check', 0, {
      type: 'defined'
    });
  },
  changed: function changed(_ref19) {
    var e = _ref19.store;
    return P('check', 1, {
      type: 'changed',
      store: e
    });
  }
},
    B = I(P, 'compute', 0),
    G = I(P, 'filter', 0),
    J = I(P, 'run', 0),
    L = function L(_ref20) {
  var e = _ref20.store;
  return T({
    from: 'stack',
    target: e
  });
};

var Q = {
  __proto__: null,
  barrier: H,
  mov: T,
  check: K,
  compute: B,
  filter: G,
  run: J,
  update: L
};

var U = function U(e) {
  return {
    id: O(),
    current: e
  };
},
    V = function V(_ref21) {
  var e = _ref21.current;
  return e;
},
    W = function W(e, _ref22, _ref23) {
  var t = _ref22.fn;
  var r = _ref23.a;
  return t(e, r);
},
    X = function X(e, _ref24, _ref25) {
  var t = _ref24.fn;
  var r = _ref25.a;
  return t(r, e);
},
    Y = function Y(e, _ref26) {
  var t = _ref26.fn;
  return t(e);
},
    Z = function Z(e) {
  return e.graphite || e;
},
    $ = function $(e) {
  return e.family.owners;
},
    ee = function ee(e) {
  return e.family.links;
},
    te = function te(e) {
  return e.stateRef;
},
    re = function re(e) {
  return e.config;
},
    ae = function ae(e) {
  return e.ɔ;
},
    ne = function ne(e) {
  return e.value;
},
    oe = function oe(e) {
  return e.subscribers;
},
    le = function le(e, t) {
  var r = Z(e);

  for (var _e7 = 0; _e7 < t.length; _e7++) {
    var _a3 = Z(t[_e7]);

    'domain' !== r.family.type && (_a3.family.type = 'crosslink'), $(_a3).push(r), ee(r).push(_a3);
  }
};

var se = function se() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var t = [];
  if (Array.isArray(e)) for (var _r4 = 0; _r4 < e.length; _r4++) {
    Array.isArray(e[_r4]) ? t.push.apply(t, _toConsumableArray(e[_r4])) : t.push(e[_r4]);
  } else t.push(e);
  return t.map(Z);
};

var ie = function ie(_ref27, a) {
  var e = _ref27.hasRef,
      t = _ref27.type,
      r = _ref27.data;
  var n;
  e && (n = r.store, a[n.id] = n), 'mov' === t && 'store' === r.to && (n = r.target, a[n.id] = n);
},
    fe = null;

var ce = function ce(e, t) {
  if (!e) return t;
  if (!t) return e;
  var r,
      a = e.v.type === t.v.type;
  return (a && e.v.id > t.v.id || !a && 'sampler' === e.v.type) && (r = e, e = t, t = r), r = ce(e.r, t), e.r = e.l, e.l = r, e;
},
    pe = [];

var ue = 0;

for (; ue < 5;) {
  pe.push({
    first: null,
    last: null,
    size: 0
  }), ue += 1;
}

var me = function me() {
  for (var _e8 = 0; _e8 < 5; _e8++) {
    var _t9 = pe[_e8];

    if (_t9.size > 0) {
      if (2 === _e8 || 3 === _e8) {
        _t9.size -= 1;
        var _e9 = fe.v;
        return fe = ce(fe.l, fe.r), _e9;
      }

      1 === _t9.size && (_t9.last = null);
      var _r5 = _t9.first;
      return _t9.first = _r5.r, _t9.size -= 1, _r5.v;
    }
  }
},
    de = function de(e, t, r, a, n) {
  return he(0, {
    a: null,
    b: null,
    node: r,
    parent: a,
    value: n,
    page: t
  }, e);
},
    he = function he(e, t, r) {
  var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var n = ge(r),
      o = pe[n],
      l = {
    v: {
      idx: e,
      stack: t,
      type: r,
      id: a
    },
    l: 0,
    r: 0
  };
  2 === n || 3 === n ? fe = ce(fe, l) : (0 === o.size ? o.first = l : o.last.r = l, o.last = l), o.size += 1;
},
    ge = function ge(e) {
  switch (e) {
    case 'child':
      return 0;

    case 'pure':
      return 1;

    case 'barrier':
      return 2;

    case 'sampler':
      return 3;

    case 'effect':
      return 4;

    default:
      return -1;
  }
},
    ye = new Set();

var be = 0,
    ke = function ke(e, t, r) {
  var a = null;
  if (e.target && (t = e.params, r = e.defer, a = e.page || a, e = e.target), Array.isArray(e)) for (var _r6 = 0; _r6 < e.length; _r6++) {
    de('pure', a, Z(e[_r6]), null, t[_r6]);
  } else de('pure', a, Z(e), null, t);
  r && be || function () {
    var e,
        t,
        r,
        a,
        n,
        o,
        l = be;
    be = 1;

    e: for (; a = me();) {
      var _a4 = a,
          _l = _a4.idx,
          _s = _a4.stack,
          _i3 = _a4.type;
      r = _s.node, n = _s.page, o = (n || r).reg;
      var _f = {
        fail: 0,
        scope: r.scope
      };
      e = t = 0;

      for (var _a5 = _l; _a5 < r.seq.length && !e; _a5++) {
        var _c = r.seq[_a5],
            _p = _c.data;

        switch (_c.type) {
          case 'barrier':
            {
              var _e10 = _p.barrierID;
              n && (_e10 = n.fullID + "_" + _e10);
              var _t10 = _p.priority;

              if (_a5 !== _l || _i3 !== _t10) {
                ye.has(_e10) || (ye.add(_e10), he(_a5, _s, _t10, _e10));
                continue e;
              }

              ye["delete"](_e10);
              break;
            }

          case 'mov':
            {
              var _e11 = void 0;

              switch (_p.from) {
                case 'stack':
                  _e11 = ne(_s);
                  break;

                case 'a':
                  _e11 = _s.a;
                  break;

                case 'b':
                  _e11 = _s.b;
                  break;

                case 'value':
                  _e11 = _p.store;
                  break;

                case 'store':
                  o[_p.store.id] || n.parent || (n = null, o = r.reg), _e11 = V(o[_p.store.id]);
              }

              switch (_p.to) {
                case 'stack':
                  _s.value = _e11;
                  break;

                case 'a':
                  _s.a = _e11;
                  break;

                case 'b':
                  _s.b = _e11;
                  break;

                case 'store':
                  o[_p.target.id].current = _e11;
              }

              break;
            }

          case 'check':
            switch (_p.type) {
              case 'defined':
                t = void 0 === ne(_s);
                break;

              case 'changed':
                t = ne(_s) === V(o[_p.store.id]);
            }

            break;

          case 'filter':
            t = !ve(_f, _p, _s);
            break;

          case 'run':
            if (_a5 !== _l || 'effect' !== _i3) {
              he(_a5, _s, 'effect');
              continue e;
            }

          case 'compute':
            _s.value = ve(_f, _p, _s);
        }

        e = _f.fail || t;
      }

      if (!e) for (var _e12 = 0; _e12 < r.next.length; _e12++) {
        de('child', n, r.next[_e12], _s, ne(_s));
      }
    }

    be = l;
  }();
};

var ve = function ve(e, _ref28, r) {
  var t = _ref28.fn;

  try {
    return t(ne(r), e.scope, r);
  } catch (t) {
    console.error(t), e.fail = 1;
  }
};

var we = function we(e, t) {
  return '' + e.shortName + t;
},
    Ne = function Ne(e, t) {
  return null == t ? we(e, ' → *') : t;
};

var qe = function qe(e, t) {
  var r = e.indexOf(t);
  -1 !== r && e.splice(r, 1);
},
    Se = function Se(e, t) {
  qe(e.next, t), qe($(e), t), qe(ee(e), t);
},
    xe = function xe(e, t, r) {
  var a;
  e.next.length = 0, e.seq.length = 0, e.scope = null;
  var n = ee(e);

  for (; a = n.pop();) {
    Se(a, e), (t || r && !e.meta.sample || 'crosslink' === a.family.type) && xe(a, t, r);
  }

  for (n = $(e); a = n.pop();) {
    Se(a, e), r && 'crosslink' === a.family.type && xe(a, t, r);
  }
},
    _e = function _e(e) {
  return e.clear();
};

var Ce = function Ce(e) {
  var _ref29 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      t = _ref29.deep;

  var r = 0;
  if (q(e)) _e(oe(e));else if (_(e)) {
    r = 1;
    var _t11 = e.history;
    _e(_t11.events), _e(_t11.effects), _e(_t11.stores), _e(_t11.domains);
  }
  xe(Z(e), !!t, r);
},
    De = function De(e) {
  var t = I(Ce, e, void 0);
  return t.unsubscribe = t, t;
},
    Ee = function Ee(e) {
  return je && le(ne(je), [e]), e;
},
    je = null,
    Ae = function Ae() {
  return je && je.template;
},
    ze = function ze(t, r, _ref30) {
  var a = _ref30.node,
      n = _ref30.scope,
      o = _ref30.meta;
  return Ee(e({
    node: a,
    parent: t,
    child: r,
    scope: n,
    meta: o,
    family: {
      owners: [t, r],
      links: r
    }
  }));
},
    Me = function Me(t) {
  var r;
  ae(t) && (r = re(t), t = ae(t));
  var _t12 = t,
      a = _t12.from,
      n = _t12.to,
      _t12$meta = _t12.meta,
      o = _t12$meta === void 0 ? {
    op: 'forward'
  } : _t12$meta;
  return a && n || D('from and to fields should be defined'), r && (o.config = r), De(Ee(e({
    parent: a,
    child: n,
    meta: o,
    family: {}
  })));
},
    Oe = function Oe(t, r) {
  return De(Ee(e({
    scope: {
      fn: r
    },
    node: [J({
      fn: Y
    })],
    parent: t,
    meta: {
      op: 'watch'
    },
    family: {
      owners: t
    }
  })));
};

var Re = function Re(e, t) {
  return E(e) && (Re(re(e), t), null != e.name && (E(e.name) ? Re(e.name, t) : t.name = e.name), e.loc && (t.loc = e.loc), e.sid && (t.sid = e.sid), e.handler && (t.handler = e.handler), e.parent && (t.parent = e.parent), 'strict' in e && (t.strict = e.strict), e.named && (t.named = e.named), Re(ae(e), t)), t;
};

var Ie,
    Pe = function Pe(_ref31, t) {
  var e = _ref31.parent;
  e && e.hooks.event(t);
},
    Fe = function Fe(e, t, r, n) {
  var o = Re({
    name: n,
    config: r
  }, {}),
      l = M(),
      _o$parent = o.parent,
      s = _o$parent === void 0 ? null : _o$parent,
      _o$sid = o.sid,
      i = _o$sid === void 0 ? null : _o$sid,
      _o$strict = o.strict,
      f = _o$strict === void 0 ? 1 : _o$strict,
      _o$named = o.named,
      c = _o$named === void 0 ? null : _o$named,
      p = c || o.name || ('domain' === e ? '' : l),
      u = a(p, s);
  return t.kind = e, t.id = l, t.sid = i, t.shortName = p, t.parent = s, t.compositeName = u, t.defaultConfig = o, t.thru = function (e) {
    return e(t);
  }, t.getType = function () {
    return u.fullName;
  }, Ie = f, {
    unit: e,
    name: p,
    sid: i,
    named: c
  };
},
    He = function He(e) {
  return o({
    named: e
  });
};

var Te = function Te(e, t, r, a) {
  return ze(e, t, {
    scope: {
      fn: a
    },
    node: [B({
      fn: Y
    })],
    meta: {
      op: r
    }
  });
},
    Ke = function Ke(e, t, r, a) {
  var n;
  E(r) && (n = r, r = r.fn);
  var l = o(we(e, ' →? *'), n);
  return ze(e, l, {
    scope: {
      fn: r
    },
    node: a,
    meta: {
      op: t
    }
  }), l;
},
    Be = function Be(e, t) {
  return t.subscribe = function (t) {
    return A(t), e.watch(function (e) {
      t.next && t.next(e);
    });
  }, t[k] = function () {
    return t;
  }, t;
},
    Ge = function Ge(e, t, r, a, n) {
  var o = te(t),
      l = [T({
    store: o,
    to: 'a'
  }), B({
    fn: a ? X : W
  }), K.defined(), K.changed({
    store: o
  }), L({
    store: o
  })],
      s = Ae();
  if (s) if (q(e)) {
    var _t13 = te(e);

    s.plain.includes(_t13) || (l.unshift(s.loader), o.before || (o.before = []), o.before.push({
      type: 'closure',
      of: _t13
    }));
  } else l.unshift(s.loader);
  return ze(e, t, {
    scope: {
      fn: n
    },
    node: l,
    meta: {
      op: r
    }
  });
};

var Je = function Je(e, t) {
  for (var _r7 in e) {
    t(e[_r7], _r7);
  }
};

var Le = function Le(e) {
  return function (t) {
    return e.apply(void 0, _toConsumableArray(t));
  };
},
    Qe = function Qe(e, r, a, n) {
  var o = e ? function (e) {
    return e.slice();
  } : function (e) {
    return Object.assign({}, e);
  },
      l = e ? [] : {},
      i = Ae(),
      f = o(l),
      c = U(f),
      p = U(1);
  c.type = e ? 'list' : 'shape', i && i.plain.push(c, p);
  var u = s(f, {
    name: a || t(r)
  }),
      m = [K.defined(), T({
    store: c,
    to: 'a'
  }), G({
    fn: function fn(e, _ref32, _ref33) {
      var t = _ref32.key;
      var r = _ref33.a;
      return e !== r[t];
    }
  }), T({
    store: p,
    to: 'b'
  }), B({
    fn: function fn(e, _ref34, a) {
      var t = _ref34.clone,
          r = _ref34.key;
      a.b && (a.a = t(a.a)), a.a[r] = e;
    }
  }), T({
    from: 'a',
    target: c
  }), T({
    from: 'value',
    store: 0,
    target: p
  }), H({
    priority: 'barrier'
  }), T({
    from: 'value',
    store: 1,
    target: p
  }), T({
    store: c
  }), n && B({
    fn: n
  }), K.changed({
    store: te(u)
  })],
      d = c.before = [];
  return Je(r, function (e, t) {
    if (!q(e)) return void (f[t] = l[t] = e);
    l[t] = e.defaultState, f[t] = e.getState();
    var r = ze(e, u, {
      scope: {
        key: t,
        clone: o
      },
      node: m,
      meta: {
        op: 'combine'
      }
    }),
        a = te(e);
    d.push({
      type: 'field',
      field: t,
      from: a
    }), i && (i.plain.includes(a) || r.seq.unshift(i.loader));
  }), u.defaultShape = r, c.after = [n ? {
    type: 'map',
    to: te(u),
    fn: n
  } : {
    type: 'copy',
    to: te(u)
  }], i || (u.defaultState = n ? te(u).current = n(f) : l), u;
};

var Ue = function Ue(_ref35) {
  var e = _ref35.params,
      t = _ref35.req,
      r = _ref35.ok,
      a = _ref35.anyway,
      n = _ref35.page;
  return function (o) {
    return ke({
      target: [a, Ve],
      params: [r ? {
        status: 'done',
        params: e,
        result: o
      } : {
        status: 'fail',
        params: e,
        error: o
      }, {
        fn: r ? t.rs : t.rj,
        value: o
      }],
      defer: 1,
      page: n
    });
  };
};

var Ve = e({
  node: [J({
    fn: function fn(_ref36) {
      var e = _ref36.fn,
          t = _ref36.value;
      e(t);
    }
  })],
  meta: {
    op: 'fx',
    fx: 'sidechain'
  }
}),
    We = function We(e, t, r) {
  return e.watch(function (e) {
    le(r, [e]), t.add(e), e.parent || (e.parent = r);
  }), le(r, [e]), function (r) {
    return t.forEach(r), e.watch(r);
  };
};

var Xe = function Xe(e) {
  return w(e) ? e : i(e);
};

var Ye = "20.14.0";
var Ze = {
  __proto__: null,
  filterChanged: G({
    fn: function fn(e, _ref37) {
      var t = _ref37.state;
      return void 0 !== e && e !== V(t);
    }
  }),
  noop: B({
    fn: function fn(e) {
      return e;
    }
  })
};
export { v as Kind, c as attach, Ze as blocks, Ce as clearNode, i as combine, p as createApi, u as createDomain, f as createEffect, o as createEvent, e as createNode, s as createStore, i as createStoreObject, Me as forward, m as fromObservable, h as guard, C as is, ke as launch, g as merge, y as restore, y as restoreEffect, y as restoreEvent, y as restoreObject, d as sample, r as setStoreName, b as split, Q as step, Ye as version, n as withRegion };